import { Map as MapLib } from "maplibre-gl";
import { mockData } from "../data";
import { GeoJSON } from "geojson";
import {
  expression,
  boolean,
  featureState,
  ifThen,
  getProperty,
  equals,
} from "./map-libre/expressions";

export const PRIVATEDATA_SOURCE = "RENEWMAP_PROJECT_SOURCE";

/**
 * We have data which is not editable. This represents such data and serves as an example
 */
export class PrivateDataManager {
  public addPrivateSources = (map: MapLib) => {
    map.addSource(PRIVATEDATA_SOURCE, {
      type: "geojson",
      promoteId: "id",
      data: mockData as GeoJSON,
    });

    map.addLayer({
      id: "user-data-fill-layer",
      source: PRIVATEDATA_SOURCE,
      type: "fill",
      paint: {
        "fill-color": "white",
        "fill-opacity": expression(
          ifThen(boolean(featureState("hover")), 0.8, 0.6),
        ),
      },
    });

    map.addLayer({
      id: "user-data-line-layer",
      source: PRIVATEDATA_SOURCE,
      type: "line",
      paint: {
        "line-color": "white",
        "line-opacity": 1,
        "line-width": expression(
          ifThen(boolean(featureState("hover")), 1.7, 1),
        ),
      },
    });

    map.addLayer({
      id: "user-data-point-layer",
      source: PRIVATEDATA_SOURCE,
      type: "circle",
      paint: {
        "circle-color": "white",
        "circle-opacity": expression(
          ifThen(boolean(featureState("hidden")), 0, 0.6),
        ),
        "circle-stroke-color": "black",
        "circle-stroke-width": 0.5,
      },
      filter: expression(equals(["geometry-type"], "Point")),
    });

    map.addLayer({
      id: "user-data-text-layer",
      source: PRIVATEDATA_SOURCE,
      type: "symbol",
      paint: {
        "text-color": "hsl(15, 0%, 100%)",
        "text-halo-blur": 1,
        "text-halo-color": "hsl(15, 0%, 0%)",
        "text-halo-width": 1,
      },
      layout: {
        visibility: "visible",
        "text-field": expression(getProperty("name")),
        "text-variable-anchor": ["bottom"],
        "text-radial-offset": 0.5,
        "text-justify": "auto",
        "icon-allow-overlap": true,
      },
      minzoom: 6,
      maxzoom: 8,
      // only render text on the points (looks weird on polygons)
      filter: expression(equals(["geometry-type"], "Point")),
    });
  };
}
